import type { Address, BuildingWithConvertedAddresses, LatLng } from './types';

export const getBuildingLikeCoordinates = (
  building: BuildingWithConvertedAddresses | null | undefined,
): LatLng | null =>
  building?.centroid ||
  building?.addresses?.[0]?.coordinates ||
  building?.properties?.addresses?.[0]?.coordinates ||
  null;

export const withLikeRequestCoordinates = (
  building: BuildingWithConvertedAddresses,
): BuildingWithConvertedAddresses => {
  const coords =
    building.addresses?.[0]?.coordinates ||
    building.properties?.addresses?.[0]?.coordinates ||
    building.centroid ||
    null;

  if (!coords || building.addresses?.[0]?.coordinates) {
    return building;
  }

  const sourceAddresses =
    building.addresses?.length > 0
      ? building.addresses
      : building.properties?.addresses || [];
  const [firstAddress, ...restAddresses] = sourceAddresses;

  return {
    ...building,
    addresses: [
      {
        ...(firstAddress || {}),
        coordinates: coords,
      } as Address,
      ...restAddresses,
    ],
  };
};
